import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Autocomplete,
	Box,
	Button,
	Checkbox,
	Chip,
	Container,
	Divider,
	FormControlLabel,
	FormGroup,
	IconButton,
	InputAdornment,
	Menu,
	TextField,
	Typography,
} from "@mui/material";
import React, { useState } from "react";
import MainDrawer from "../MainDrawer";
import queryGraphql from "../../helpers/ApiInterface";
import { useAuth } from "../../helpers/AuthProvider";
import { useNavigate } from "react-router-dom";
import { ExpandMore } from "@mui/icons-material";
import ServicesTable from "./ServicesTable";
import MiniBot from "../MiniBot";
interface SearchOptions {
	chipLabel: string;
	dropdownLabel: string;
	category: string;
	groupBy: string;
}
let searchOptions: SearchOptions[] = [];
const ServicesPage: React.FC = () => {
	const [services, setServices] = useState([]);
	const { user } = useAuth();
	const navigate = useNavigate();
	const [searchQuery, setSearchQuery] = useState<SearchOptions[]>([]);
	const [updates, setUpdates] =  useState<any>([]);

	const [columnFilters, setColumnFilters] = useState<Record<string, boolean>>({
		serviceName: true,
		applicationName: true,
		framework: true,
		clusterName: true,
		serviceOwner: true,
		createdAt: true,
	});
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const handleFilterClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleFilterClose = () => {
		setAnchorEl(null);
	};
	const toggleColumnFilter = (column: string) => {
		setColumnFilters((prevFilters) => ({
			...prevFilters,
			[column]: !prevFilters[column],
		}));
	};
	

	React.useEffect(() =>{
		const fetchData = async () => {
			try {
				const data = await queryGraphql(`
                        query Query {
						resourceStatuses {
							id
							currentStatus
							resourceId
						}
						}
					`);
				if(data.resourceStatuses){
					setUpdates(data.resourceStatuses);
					
				}
				}
				catch(e){
			console.log(e);
				}
	}
	fetchData();
	},[]);	
	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const data = await queryGraphql(`
                        query{
						services{
						id,
						serviceName,
					
						framework,
						serviceOwner{
						id,
						name,email,
						googleProfilePicture
						},
						application{
						id,
						applicationName,
						cluster{
						id,
						clusterName,
				}
						},
						createdAt,
						status
						}
				}
					`);

				let servicesArr = data.services.map((e: any) => {
					let rand = Math.random() * 8;

					return {
						...e,

						serviceOwnerAvatar: e?.serviceOwner?.googleProfilePicture,
						serviceOwner: e?.serviceOwner?.name,
						createdAt: new Date(Number(e.createdAt)).toISOString(),
						clusterName: e?.application?.cluster?.clusterName,
						applicationName: e?.application?.applicationName,
					};
				});
				setServices(servicesArr);
				searchOptions = servicesArr
					.map((e: any) => {
						return [
							{
								category: "serviceName",
								groupBy: "SERVICE NAME",
								chipLabel: `Service Name: ${e.serviceName}`,
								dropdownLabel: e.serviceName,
							},
							{
								category: "framework",
								groupBy: "FRAMEWORK",
								chipLabel: `Framework: ${e.framework}`,
								dropdownLabel: e.framework,
							},
							{
								category: "clusterName",
								groupBy: "CLUSTER NAME",
								chipLabel: `Cluster Name: ${e.clusterName}`,
								dropdownLabel: e.clusterName,
							},
							{
								category: "applicationName",
								groupBy: "APPLICATION NAME",
								chipLabel: `Application Name: ${e.applicationName}`,
								dropdownLabel: e.applicationName,
							},
							{
								category: "serviceOwner",
								groupBy: "OWNER",
								chipLabel: `Owner: ${e.serviceOwner}`,
								dropdownLabel: e.serviceOwner,
							},
						];
					})
					.flat();

				searchOptions = searchOptions.filter(
					(obj, index, self) =>
						index ===
						self.findIndex(
							(t) => t.category === obj.category && t.dropdownLabel === obj.dropdownLabel
						)
				);
				searchOptions.sort((a, b) => {
					if (a.groupBy > b.groupBy) return 1;
					if (a.groupBy < b.groupBy) return -1;
					if (a.dropdownLabel > b.dropdownLabel) return 1;
					if (a.dropdownLabel < b.dropdownLabel) return -1;
					return 0;
				});
			} catch (error) {
				console.log(error);
			}
		};

		fetchData();
	}, []);
	const filteredServices =
		searchQuery.length == 0
			? services
			: services.filter(
					(service: any) =>
						(searchQuery.filter((e) => e.category == "serviceName").length > 0
							? searchQuery
									.filter((e) => e.category == "serviceName")
									.map((e) => e.dropdownLabel.toLowerCase())
									.includes(service.serviceName.toLowerCase())
							: true) &&
						(searchQuery.filter((e) => e.category == "framework").length > 0
							? searchQuery
									.filter((e) => e.category == "framework")
									.map((e) => e.dropdownLabel.toLowerCase())
									.includes(service.framework.toLowerCase())
							: true) &&
						(searchQuery.filter((e) => e.category == "serviceName").length > 0
							? searchQuery
									.filter((e) => e.category == "serviceName")
									.map((e) => e.dropdownLabel.toLowerCase())
									.includes(service.serviceName.toLowerCase())
							: true) &&
						(searchQuery.filter((e) => e.category == "clusterName").length > 0
							? searchQuery
									.filter((e) => e.category == "clusterName")
									.map((e) => e.dropdownLabel.toLowerCase())
									.includes(service.clusterName.toLowerCase())
							: true) &&
						(searchQuery.filter((e) => e.category == "applicationName").length > 0
							? searchQuery
									.filter((e) => e.category == "applicationName")
									.map((e) => e.dropdownLabel.toLowerCase())
									.includes(service.applicationName.toLowerCase())
							: true) &&
						(searchQuery.filter((e) => e.category == "serviceOwner").length > 0
							? searchQuery
									.filter((e) => e.category == "serviceOwner")
									.map((e) => e.dropdownLabel.toLowerCase())
									.includes(service.serviceOwner.toLowerCase())
							: true)
			  );

	const filteredActiveServices = filteredServices.filter(
		(service: any) => service.status === "active" 
	);
	const filteredPendingServices = filteredServices.filter(
		(service: any) => service.status === "pending"
	);
	const filteredRejectedServices = filteredServices.filter(
		(service: any) => service.status === "rejected" 
	);
	return (
		<Box sx={{ display: "flex" }}>
			<MiniBot/>
			<MainDrawer index={"services"} />
			<Box
				component="main"
				// display="inline-block"
				sx={{
					flex: 1,
					bgcolor: "#fafafa",

					minHeight: window.innerHeight,
				}}
			>
				<Container maxWidth={false} disableGutters>
					<Box bgcolor="#FFFFFF" p={2} mb="18px">
						<Box
							sx={{
								display: "flex",
								justifyContent: "space-between",
								alignItems: "center",
								marginBottom: 1,
								mx: 2,
							}}
						>
							
							<Typography fontSize="22px" gutterBottom fontFamily="Gilroy-Bold">
								Services
							</Typography>
							<Box sx={{display:'flex', justifyContent:'center'}}>
							<Button
								variant="contained"
								color="primary"
								disabled={!user.roles?.some((e: string) => ["developer", "viewer"].includes(e))}
								sx={{
									backgroundColor: "black",
									color: "white",
									padding: "8px 24px",
									fontSize: "0.875rem",
									textTransform: "none",
								}}
								onClick={() => navigate("/services/add")}
							>
								<Typography fontSize="14px" fontFamily="Gilroy-Bold">
									Add New Service
								</Typography>
							</Button>
							
							<IconButton
									  aria-label="Help" 
									  onClick={()=> window.open(`${process.env.REACT_APP_HOST_DOMAIN}/docs` , "_blank")}
									  sx={{
										padding: 0, 
										border: 'none',  
										ml:2,
										'&:hover': {
										  
										  backgroundColor: 'action.hover', 
										},
										
									  }}
									>
									  <Box
										component="img"
										src="/assets/Help.svg" 
										alt="" 
										sx={{
										  width: 40,  
										  height: 40,
										  display: 'block', 
										}}
									  />
									</IconButton>
							</Box>
						</Box>
						<Divider sx={{ marginY: 1 }} />
						<Box sx={{ display: "flex", alignItems: "center", ml: 1 }}>
							<Autocomplete
								multiple
								options={searchOptions}
								filterSelectedOptions
								getOptionLabel={(option) => option.dropdownLabel}
								defaultValue={[]}
								groupBy={(option) => option.groupBy}
								renderTags={(tagValue, getTagProps) => {
									return tagValue.map((option, index) => (
										<Chip {...getTagProps({ index })} size="small" label={option.chipLabel} />
									));
								}}
								onChange={(e, newVal, reason) => {
									setSearchQuery(newVal);
								}}
								renderInput={(params) => (
									<TextField
										{...params}
										variant="filled"
										placeholder="Search by service name, environment, owner etc"
										fullWidth
										size="small"
										hiddenLabel
										InputProps={{
											...params.InputProps,
											startAdornment: (
												<>
													<InputAdornment position="start">
														<img
															src="/assets/search-normal.svg"
															alt="Filter Icon"
															style={{ width: "16px", paddingLeft: "4px" }}
														/>
													</InputAdornment>
													{params.InputProps.startAdornment}
												</>
											),
											disableUnderline: true,
											style: {
												backgroundColor: "#f4f4f4",
												minHeight: "45px",
												width: "500px",
												borderRadius: "8px",
												fontFamily: "Gilroy-Regular",
												fontSize: "14px",
											},
										}}
									/>
								)}
							/>

							<Button
								sx={{
									marginLeft: "16px",
									border: "1px solid #bbb",
									borderRadius: "10px",
									height: "45px",
									width: "45px",
								}}
								onClick={handleFilterClick}
							>
								<img src="/assets/pause.svg" alt="Filter Icon" style={{ width: "16px" }} />
							</Button>
							<Menu
								anchorEl={anchorEl}
								open={Boolean(anchorEl)}
								onClose={handleFilterClose}
								anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
							>
								<Box sx={{ padding: "8px" }}>
									<Typography sx={{ fontWeight: "bold", marginBottom: "8px" }}>
										TABLE COLUMNS
									</Typography>
									<FormGroup>
										{Object.keys(columnFilters).map((column) => (
											<FormControlLabel
												key={column}
												control={
													<Checkbox
														checked={columnFilters[column as keyof typeof columnFilters]}
														onChange={() => toggleColumnFilter(column)}
														sx={{
															color: "#000", // Black color for the checkbox
															"&.Mui-checked": {
																color: "#000", // Black color when checked
															},
															"& .MuiSvgIcon-root": {
																borderRadius: "50%", // Rounded shape for the checkbox icon
															},
														}}
													/>
												}
												label={
													column.charAt(0).toUpperCase() +
													column
														.slice(1)
														.replace(/([A-Z])/g, " $1")
														.trim()
												}
											/>
										))}
									</FormGroup>
									<Button
										variant="contained"
										onClick={handleFilterClose}
										sx={{
											marginTop: "8px",
											backgroundColor: "black",
											color: "white",
											width: "100%",
										}}
									>
										Apply
									</Button>
								</Box>
							</Menu>
						</Box>
					</Box>
					<Box m={2}>
						{filteredPendingServices.length > 0 && (
							<Accordion
								defaultExpanded={filteredPendingServices.length > 0 ? true : false}
								elevation={0}
								sx={{
									borderRadius: "8px",
									mb: "16px",
									"&:before": {
										display: "none",
									},
									bgcolor: "#fafafa",
								}}
								disabled={filteredPendingServices.length == 0}
							>
								<AccordionSummary expandIcon={<ExpandMore />}>
									<Box sx={{ display: "flex", alignItems: "center" }}>
										<img
											src="/assets/clock.svg"
											alt="Pending Icon"
											style={{ width: "20px", marginRight: "8px" }}
										/>
										<Typography fontSize="16px" fontFamily="Gilroy-SemiBold">
											Pending Services ({filteredPendingServices.length})
										</Typography>
									</Box>
								</AccordionSummary>
								<AccordionDetails>
									{filteredPendingServices.length > 0 && (
										<ServicesTable
											services={filteredPendingServices}
											columnFilters={columnFilters}
											type="pending"
											resourceStatuses={updates}
										/>
									)}
								</AccordionDetails>
							</Accordion>
						)}
						{filteredActiveServices.length > 0 && (
							<Accordion
							defaultExpanded={true}
								elevation={0}
								sx={{
									borderRadius: "8px",
									mb: "16px",
									"&:before": {
										display: "none",
									},
									bgcolor: "#fafafa",
								}}
								disabled={filteredActiveServices.length == 0}
							>
								<AccordionSummary expandIcon={<ExpandMore />}>
									<Box sx={{ display: "flex", alignItems: "center" }}>
										<img
											src="/assets/tickcircle.svg"
											alt="Active Icon"
											style={{ width: "20px", marginRight: "8px" }}
										/>
										<Typography fontSize="16px" fontFamily="Gilroy-SemiBold">
											Active Services ({filteredActiveServices.length})
										</Typography>
									</Box>
								</AccordionSummary>
								<AccordionDetails>
									{filteredActiveServices.length > 0 && (
										<ServicesTable
											services={filteredActiveServices}
											columnFilters={columnFilters}
											type="active"
											resourceStatuses={updates}
										/>
									)}
								</AccordionDetails>
							</Accordion>
						)}

						{filteredRejectedServices.length > 0 && (
							<Accordion
								elevation={0}
								sx={{
									borderRadius: "8px",
									"&:before": {
										display: "none",
									},
									bgcolor: "#fafafa",
								}}
								disabled={filteredRejectedServices.length == 0}
							>
								<AccordionSummary expandIcon={<ExpandMore />}>
									<Box sx={{ display: "flex", alignItems: "center" }}>
										<img
											src="/assets/reject.svg"
											alt="Rejected Icon"
											style={{ width: "20px", marginRight: "8px" }}
										/>
										<Typography fontSize="16px" fontFamily="Gilroy-SemiBold">
											Rejected Services ({filteredRejectedServices.length})
										</Typography>
									</Box>
								</AccordionSummary>
								<AccordionDetails>
									{filteredRejectedServices.length > 0 && (
										<ServicesTable
											services={filteredRejectedServices}
											columnFilters={columnFilters}
											type="rejected"
											resourceStatuses={updates}
										/>
									)}
								</AccordionDetails>
							</Accordion>
						)}
					</Box>
				</Container>
			</Box>
		</Box>
	);
};

export default ServicesPage;
